import { Controller } from "@hotwired/stimulus"

// The home page's sample estimate (home/_work_order). The name typed in the hero is printed at the top of the
// estimate, its first letter as the mark, and goes along in every link to a tool, so the tool opens already dressed
// for this business. Without JavaScript the page stays dressed as the example, and the form still carries whatever
// was typed.
export default class extends Controller {
  static targets = ["input", "name", "initial", "example", "tool"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasInputTarget) return
    const typed = this.inputTarget.value.trim()

    const name = typed || this.inputTarget.placeholder

    this.nameTargets.forEach((element) => (element.textContent = name))
    this.initialTargets.forEach((element) => (element.textContent = (Array.from(name)[0] || "").toUpperCase()))
    this.exampleTargets.forEach((element) => (element.hidden = typed !== ""))
    this.carry(typed)
  }

  // The same query string as ToolsHelper#carried: the name if one was typed. An empty field loses its name so the
  // form leaves it out too, keeping the address short.
  carry(typed) {
    const query = new URLSearchParams()
    if (typed) query.set("q", typed)

    this.inputTarget.name = typed ? "q" : ""
    this.toolTargets.forEach((link) => {
      const url = new URL(link.href)
      url.search = query
      link.href = url
    })
  }
}
